export default [
    {
        logoId: 1,
        name: "Ataque Poderoso",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 16,
                cast: 0,
                info: "Rapidamente ataca o alvo causando 33 de dano físico.",
                necessaryLevel: 1,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 19,
                cast: 0,
                info: "Rapidamente ataca o alvo causando 39 de dano físico.",
                necessaryLevel: 4,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 26,
                cast: 0,
                info: "Rapidamente ataca o alvo causando 53 de dano físico.",
                necessaryLevel: 8,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 33,
                cast: 0,
                info: "Rapidamente ataca o alvo causando 59 de dano físico.",
                necessaryLevel: 12,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 41,
                cast: 0,
                info: "Rapidamente ataca o alvo causando 85 de dano físico.",
                necessaryLevel: 16,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 50,
                cast: 0,
                info: "Rapidamente ataca o alvo causando 105 de dano físico.",
                necessaryLevel: 20,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 61,
                cast: 0,
                info: "Rapidamente ataca o alvo causando 127 de dano físico.",
                necessaryLevel: 24,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 74,
                cast: 0,
                info: "Rapidamente ataca o alvo causando 155 de dano físico.",
                necessaryLevel: 28,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 90,
                cast: 0,
                info:
                    "Rapidamente ataca até 2 alvos causando 188 de dano físico e a habilidade possui 15 de critico adicional.",
                necessaryLevel: 32,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 109,
                cast: 0,
                info:
                    "Rapidamente ataca até 2 alvos causando 228 de dano físico e a habilidade possui 20 de critico adicional.",
                necessaryLevel: 36,
            },
            {
                level: 11,
                cooldown: 6,
                mp: 132,
                cast: 0,
                info:
                    "Rapidamente ataca até 2 alvos causando 275 de dano físico e a habilidade possui 25 de critico adicional.",
                necessaryLevel: 40,
            },
            {
                level: 12,
                cooldown: 6,
                mp: 156,
                cast: 0,
                info:
                    "Rapidamente ataca até 2 alvos causando 325 de dano físico e a habilidade possui 30 de critico adicional.",
                necessaryLevel: 44,
            },
            {
                level: 13,
                cooldown: 6,
                mp: 184,
                cast: 0,
                info:
                    "Rapidamente ataca até 2 alvos causando 383 de dano físico e a habilidade possui 35 de critico adicional.",
                necessaryLevel: 48,
            },
            {
                level: 14,
                cooldown: 6,
                mp: 213,
                cast: 0,
                info:
                    "Rapidamente ataca até 2 alvos causando 444 de dano físico e a habilidade possui 40 de critico adicional.",
                necessaryLevel: 52,
            },
            {
                level: 15,
                cooldown: 6,
                mp: 247,
                cast: 0,
                info:
                    "Rapidamente ataca até 2 alvos causando 515 de dano físico e a habilidade possui 45 de critico adicional.",
                necessaryLevel: 56,
            },
            {
                level: 16,
                cooldown: 6,
                mp: 284,
                cast: 0,
                info:
                    "Rapidamente ataca até 2 alvos causando 592 de dano físico e a habilidade possui 50 de critico adicional.",
                necessaryLevel: 60,
            },
        ],
    },
    {
        logoId: 2,
        name: "Avanço Poderoso",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 30,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 8 metros causando 13 de dano físico e atordoando-o por 3 segundos.",
                necessaryLevel: 4,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 41,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 8 metros causando 17 de dano físico e atordoando-o por 3 segundos.",
                necessaryLevel: 8,
            },
            {
                level: 3,
                cooldown: 19,
                mp: 51,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 9 metros causando 22 de dano físico e atordoando-o por 3 segundos.",
                necessaryLevel: 12,
            },
            {
                level: 4,
                cooldown: 19,
                mp: 63,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 9 metros causando 27 de dano físico e atordoando-o por 3 segundos.",
                necessaryLevel: 16,
            },
            {
                level: 5,
                cooldown: 18,
                mp: 79,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 10 metros causando 34 de dano físico e atordoando-o por 3 segundos.",
                necessaryLevel: 20,
            },
            {
                level: 6,
                cooldown: 18,
                mp: 95,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 10 metros causando 41 de dano físico e atordoando-o por 3 segundos.",
                necessaryLevel: 24,
            },
            {
                level: 7,
                cooldown: 17,
                mp: 115,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 11 metros causando 50 de dano físico e atordoando-o por 3 segundos.",
                necessaryLevel: 28,
            },
            {
                level: 8,
                cooldown: 17,
                mp: 139,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 11 metros causando 60 de dano físico e atordoando-o por 3 segundos.",
                necessaryLevel: 32,
            },
            {
                level: 9,
                cooldown: 16,
                mp: 169,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 12 metros causando 73 de dano físico e atordoando-o por 3 segundos.",
                necessaryLevel: 36,
            },
            {
                level: 10,
                cooldown: 14,
                mp: 203,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 12 metros causando 88 de dano físico e atordoando-o por 3 segundos.",
                necessaryLevel: 40,
            },
        ],
    },
    {
        logoId: 3,
        name: "Quebrar Armadura",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 30,
                cast: 0,
                info:
                    "Ataca o alvo causando 62 de dano físico e quebra sua armadura reduzindo 100 de sua defesa física, 4 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 6,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 38,
                cast: 0,
                info:
                    "Ataca o alvo causando 80 de dano físico e quebra sua armadura reduzindo 131 de sua defesa física, 6 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 10,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 48,
                cast: 0,
                info:
                    "Ataca o alvo causando 101 de dano físico e quebra sua armadura reduzindo 164 de sua defesa física, 8 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 14,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 60,
                cast: 0,
                info:
                    "Ataca o alvo causando 124 de dano físico e quebra sua armadura reduzindo 203 de sua defesa física, 10 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 18,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 73,
                cast: 0,
                info:
                    "Ataca o alvo causando 152 de dano físico e quebra sua armadura reduzindo 258 de sua defesa física, 12 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 22,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 89,
                cast: 0,
                info:
                    "Ataca o alvo causando 185 de dano físico e quebra sua armadura reduzindo 319 de sua defesa física, 14 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 26,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 108,
                cast: 0,
                info:
                    "Ataca o alvo causando 225 de dano físico e quebra sua armadura reduzindo 385 de sua defesa física, 16 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 30,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 131,
                cast: 0,
                info:
                    "Ataca o alvo causando 272 de dano físico e quebra sua armadura reduzindo 467 de sua defesa física, 18 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 34,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 158,
                cast: 0,
                info:
                    "Ataca o alvo causando 330 de dano físico e quebra sua armadura reduzindo 566 de sua defesa física, 20 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 38,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 188,
                cast: 0,
                info:
                    "Ataca o alvo causando 391 de dano físico e quebra sua armadura reduzindo 671 de sua defesa física, 22 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 42,
            },
            {
                level: 11,
                cooldown: 12,
                mp: 221,
                cast: 0,
                info:
                    "Ataca o alvo causando 461 de dano físico e quebra sua armadura reduzindo 792 de sua defesa física, 24 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 46,
            },
            {
                level: 12,
                cooldown: 12,
                mp: 260,
                cast: 0,
                info:
                    "Ataca o alvo causando 542 de dano físico e quebra sua armadura reduzindo 946 de sua defesa física, 26 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 50,
            },
            {
                level: 13,
                cooldown: 12,
                mp: 301,
                cast: 0,
                info:
                    "Ataca o alvo causando 628 de dano físico e quebra sua armadura reduzindo 1120 de sua defesa física, 28 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 54,
            },
            {
                level: 14,
                cooldown: 12,
                mp: 348,
                cast: 0,
                info:
                    "Ataca o alvo causando 725 de dano físico e quebra sua armadura reduzindo 1299 de sua defesa física, 30 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 58,
            },
            {
                level: 15,
                cooldown: 12,
                mp: 396,
                cast: 0,
                info:
                    "Ataca o alvo causando 824 de dano físico e quebra sua armadura reduzindo 1484 de sua defesa física, 32 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 62,
            },
            {
                level: 16,
                cooldown: 12,
                mp: 445,
                cast: 0,
                info:
                    "Ataca o alvo causando 927 de dano físico e quebra sua armadura reduzindo 1672 de sua defesa física, 34 de esquiva e 7 de velocidade de movimento durante 12 segundos.",
                necessaryLevel: 66,
            },
        ],
    },
    {
        logoId: 4,
        name: "Incitar",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 18,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 1 sua taxa de perigo e obriga-o a fixar o olhar em você por 3 segundos.",
                necessaryLevel: 8,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 23,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 2 sua taxa de perigo e obriga-o a fixar o olhar em você por 3 segundos.",
                necessaryLevel: 12,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 28,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 3 sua taxa de perigo e obriga-o a fixar o olhar em você por 3 segundos.",
                necessaryLevel: 16,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 34,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 4 sua taxa de perigo e obriga-o a fixar o olhar em você por 3 segundos.",
                necessaryLevel: 20,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 41,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 5 sua taxa de perigo e obriga-o a fixar o olhar em você por 4 segundos.",
                necessaryLevel: 24,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 49,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 6 sua taxa de perigo e obriga-o a fixar o olhar em você por 4 segundos.",
                necessaryLevel: 28,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 59,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 7 sua taxa de perigo e obriga-o a fixar o olhar em você por 4 segundos.",
                necessaryLevel: 32,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 71,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 8 sua taxa de perigo e obriga-o a fixar o olhar em você por 4 segundos.",
                necessaryLevel: 36,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 83,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 9 sua taxa de perigo e obriga-o a fixar o olhar em você por 5 segundos.",
                necessaryLevel: 40,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 97,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 10 sua taxa de perigo e obriga-o a fixar o olhar em você por 5 segundos.",
                necessaryLevel: 44,
            },
            {
                level: 11,
                cooldown: 12,
                mp: 113,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 11 sua taxa de perigo e obriga-o a fixar o olhar em você por 5 segundos.",
                necessaryLevel: 48,
            },
            {
                level: 12,
                cooldown: 12,
                mp: 129,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 12 sua taxa de perigo e obriga-o a fixar o olhar em você por 5 segundos.",
                necessaryLevel: 52,
            },
            {
                level: 13,
                cooldown: 12,
                mp: 148,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 13 sua taxa de perigo e obriga-o a fixar o olhar em você por 6 segundos.",
                necessaryLevel: 56,
            },
            {
                level: 14,
                cooldown: 12,
                mp: 166,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 14 sua taxa de perigo e obriga-o a fixar o olhar em você por 6 segundos.",
                necessaryLevel: 60,
            },
            {
                level: 15,
                cooldown: 12,
                mp: 185,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 15 sua taxa de perigo e obriga-o a fixar o olhar em você por 6 segundos.",
                necessaryLevel: 64,
            },
            {
                level: 16,
                cooldown: 12,
                mp: 206,
                cast: 0,
                info:
                    "Provoca o alvo aumentando em 16 sua taxa de perigo e obriga-o a fixar o olhar em você por 6 segundos.",
                necessaryLevel: 68,
            },
        ],
    },
    {
        logoId: 5,
        name: "Fúria",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 76,
                cast: 2,
                info:
                    "Entra em estado de frenesi que absorve 6% do seu dano causado como vida, aumenta em 12 sua velocidade de movimento e reduz em 5 da sua esquiva durante 10 minutos.",
                necessaryLevel: 10,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 94,
                cast: 2,
                info:
                    "Entra em estado de frenesi que absorve 8% do seu dano causado como vida, aumenta em 12 sua velocidade de movimento e reduz em 6 da sua esquiva durante 10 minutos.",
                necessaryLevel: 14,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 112,
                cast: 2,
                info:
                    "Entra em estado de frenesi que absorve 10% do seu dano causado como vida, aumenta em 12 sua velocidade de movimento e reduz em 7 da sua esquiva durante 10 minutos.",
                necessaryLevel: 18,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 135,
                cast: 2,
                info:
                    "Entra em estado de frenesi que absorve 12% do seu dano causado como vida, aumenta em 12 sua velocidade de movimento e reduz em 8 da sua esquiva durante 10 minutos.",
                necessaryLevel: 22,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 162,
                cast: 2,
                info:
                    "Entra em estado de frenesi que absorve 14% do seu dano causado como vida, aumenta em 12 sua velocidade de movimento e reduz em 9 da sua esquiva durante 10 minutos.",
                necessaryLevel: 26,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 194,
                cast: 2,
                info:
                    "Entra em estado de frenesi que absorve 16% do seu dano causado como vida, aumenta em 12 sua velocidade de movimento e reduz em 10 da sua esquiva durante 10 minutos.",
                necessaryLevel: 30,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 231,
                cast: 2,
                info:
                    "Entra em estado de frenesi que absorve 18% do seu dano causado como vida, aumenta em 12 sua velocidade de movimento e reduz em 11 da sua esquiva durante 10 minutos.",
                necessaryLevel: 34,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 270,
                cast: 2,
                info:
                    "Entra em estado de frenesi que absorve 20% do seu dano causado como vida, aumenta em 12 sua velocidade de movimento e reduz em 12 da sua esquiva durante 10 minutos.",
                necessaryLevel: 38,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 316,
                cast: 2,
                info:
                    "Entra em estado de frenesi que absorve 22% do seu dano causado como vida, aumenta em 12 sua velocidade de movimento e reduz em 13 da sua esquiva durante 10 minutos.",
                necessaryLevel: 42,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 363,
                cast: 2,
                info:
                    "Entra em estado de frenesi que absorve 24% do seu dano causado como vida, aumenta em 12 sua velocidade de movimento e reduz em 15 da sua esquiva durante 10 minutos.",
                necessaryLevel: 46,
            },
        ],
    },
    {
        logoId: 6,
        name: "Tempestade de Lâminas",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 79,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 152 de dano físico.",
                necessaryLevel: 12,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 99,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 191 de dano físico.",
                necessaryLevel: 16,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 122,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 234 de dano físico.",
                necessaryLevel: 20,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 147,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 283 de dano físico.",
                necessaryLevel: 24,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 178,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 343 de dano físico.",
                necessaryLevel: 28,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 216,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 415 de dano físico.",
                necessaryLevel: 32,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 262,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 504 de dano físico.",
                necessaryLevel: 36,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 312,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 600 de dano físico.",
                necessaryLevel: 40,
            },
            {
                level: 9,
                cooldown: 20,
                mp: 369,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 709 de dano físico.",
                necessaryLevel: 44,
            },
            {
                level: 10,
                cooldown: 20,
                mp: 435,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 837 de dano físico.",
                necessaryLevel: 48,
            },
            {
                level: 11,
                cooldown: 20,
                mp: 504,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 969 de dano físico.",
                necessaryLevel: 52,
            },
            {
                level: 12,
                cooldown: 20,
                mp: 583,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 1121 de dano físico.",
                necessaryLevel: 56,
            },
            {
                level: 13,
                cooldown: 20,
                mp: 665,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 1279 de dano físico.",
                necessaryLevel: 60,
            },
            {
                level: 14,
                cooldown: 20,
                mp: 747,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 1437 de dano físico.",
                necessaryLevel: 64,
            },
            {
                level: 15,
                cooldown: 20,
                mp: 841,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 1618 de dano físico.",
                necessaryLevel: 68,
            },
            {
                level: 16,
                cooldown: 20,
                mp: 946,
                cast: 0,
                info:
                    "Gira sua espada criando uma tempestade em volta do alvo selecionado em um raio 4 metros que causa 1819 de dano físico.",
                necessaryLevel: 72,
            },
        ],
    },
    {
        logoId: 7,
        name: "Canção da Glória",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 54,
                cast: 0,
                info:
                    "Aumenta 215 da vida máxima e 107 da mana máxima e melhora a regeneração de vida em 56 e a regeneração de mana em 28 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 17,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 66,
                cast: 0,
                info:
                    "Aumenta 262 da vida máxima e 131 da mana máxima e melhora a regeneração de vida em 67 e a regeneração de mana em 34 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 21,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 78,
                cast: 0,
                info:
                    "Aumenta 313 da vida máxima e 156 da mana máxima e melhora a regeneração de vida em 81 e a regeneração de mana em 41 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 25,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 94,
                cast: 0,
                info:
                    "Aumenta 376 da vida máxima e 188 da mana máxima e melhora a regeneração de vida em 98 e a regeneração de mana em 49 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 29,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 113,
                cast: 0,
                info:
                    "Aumenta 452 da vida máxima e 226 da mana máxima e melhora a regeneração de vida em 119 e a regeneração de mana em 60 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 33,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 136,
                cast: 0,
                info:
                    "Aumenta 542 da vida máxima e 271 da mana máxima e melhora a regeneração de vida em 141 e a regeneração de mana em 71 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 37,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 160,
                cast: 0,
                info:
                    "Aumenta 640 da vida máxima e 320 da mana máxima e melhora a regeneração de vida em 166 e a regeneração de mana em 83 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 41,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 187,
                cast: 0,
                info:
                    "Aumenta 748 da vida máxima e 374 da mana máxima e melhora a regeneração de vida em 195 e a regeneração de mana em 97 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 45,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 218,
                cast: 0,
                info:
                    "Aumenta 873 da vida máxima e 436 da mana máxima e melhora a regeneração de vida em 225 e a regeneração de mana em 112 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 49,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 250,
                cast: 0,
                info:
                    "Aumenta 1000 da vida máxima e 500 da mana máxima e melhora a regeneração de vida em 257 e a regeneração de mana em 128 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 53,
            },
            {
                level: 11,
                cooldown: 12,
                mp: 287,
                cast: 0,
                info:
                    "Aumenta 1148 da vida máxima e 573 da mana máxima e melhora a regeneração de vida em 292 e a regeneração de mana em 146 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 57,
            },
            {
                level: 12,
                cooldown: 12,
                mp: 324,
                cast: 0,
                info:
                    "Aumenta 1295 da vida máxima e 646 da mana máxima e melhora a regeneração de vida em 331 e a regeneração de mana em 166 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 61,
            },
            {
                level: 13,
                cooldown: 12,
                mp: 360,
                cast: 0,
                info:
                    "Aumenta 1441 da vida máxima e 720 da mana máxima e melhora a regeneração de vida em 372 e a regeneração de mana em 187 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 65,
            },
            {
                level: 14,
                cooldown: 12,
                mp: 401,
                cast: 0,
                info:
                    "Aumenta 1604 da vida máxima e 802 da mana máxima e melhora a regeneração de vida em 414 e a regeneração de mana em 208 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 69,
            },
            {
                level: 15,
                cooldown: 12,
                mp: 446,
                cast: 0,
                info:
                    "Aumenta 1784 da vida máxima e 892 da mana máxima e melhora a regeneração de vida em 461 e a regeneração de mana em 231 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 73,
            },
            {
                level: 16,
                cooldown: 12,
                mp: 492,
                cast: 0,
                info:
                    "Aumenta 1967 da vida máxima e 983 da mana máxima e melhora a regeneração de vida em 513 e a regeneração de mana em 257 de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 77,
            },
        ],
    },
    {
        logoId: 8,
        name: "Resoluto",
        levelsInfo: [
            {
                level: 1,
                cooldown: 30,
                mp: 84,
                cast: 0,
                info:
                    "Acerta o alvo derrubando-o no chão causando 48 de dano físico. O alvo se recompõe após 1 ataque ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 19,
            },
            {
                level: 2,
                cooldown: 29,
                mp: 103,
                cast: 0,
                info:
                    "Acerta o alvo derrubando-o no chão causando 59 de dano físico. O alvo se recompõe após 1 ataque ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 23,
            },
            {
                level: 3,
                cooldown: 28,
                mp: 124,
                cast: 0,
                info:
                    "Acerta o alvo derrubando-o no chão causando 71 de dano físico. O alvo se recompõe após 2 ataques ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 27,
            },
            {
                level: 4,
                cooldown: 27,
                mp: 150,
                cast: 0,
                info:
                    "Acerta o alvo derrubando-o no chão causando 86 de dano físico. O alvo se recompõe após 2 ataques ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 31,
            },
            {
                level: 5,
                cooldown: 26,
                mp: 182,
                cast: 0,
                info:
                    "Acerta o alvo derrubando-o no chão causando 104 de dano físico. O alvo se recompõe após 3 ataques ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 35,
            },
            {
                level: 6,
                cooldown: 25,
                mp: 220,
                cast: 0,
                info:
                    "Acerta o alvo derrubando-o no chão causando 126 de dano físico. O alvo se recompõe após 3 ataques ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 39,
            },
            {
                level: 7,
                cooldown: 24,
                mp: 260,
                cast: 0,
                info:
                    "Acerta o alvo derrubando-o no chão causando 149 de dano físico. O alvo se recompõe após 4 ataques ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 43,
            },
            {
                level: 8,
                cooldown: 23,
                mp: 307,
                cast: 0,
                info:
                    "Acerta o alvo derrubando-o no chão causando 176 de dano físico. O alvo se recompõe após 4 ataques ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 47,
            },
            {
                level: 9,
                cooldown: 22,
                mp: 358,
                cast: 0,
                info:
                    "Acerta o alvo derrubando-o no chão causando 205 de dano físico. O alvo se recompõe após 5 ataques ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 51,
            },
            {
                level: 10,
                cooldown: 20,
                mp: 413,
                cast: 0,
                info:
                    "Acerta o alvo derrubando-o no chão causando 237 de dano físico. O alvo se recompõe após 5 ataques ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 55,
            },
        ],
    },
    {
        logoId: 9,
        name: "Fortitude",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta 2 de ataque físico e 4 de acerto.",
                necessaryLevel: 21,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta 4 de ataque físico e 8 de acerto.",
                necessaryLevel: 25,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta 6 de ataque físico e 12 de acerto.",
                necessaryLevel: 29,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta 8 de ataque físico e 16 de acerto.",
                necessaryLevel: 33,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta 10 de ataque físico e 20 de acerto.",
                necessaryLevel: 37,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta 12 de ataque físico e 24 de acerto.",
                necessaryLevel: 41,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta 14 de ataque físico e 28 de acerto.",
                necessaryLevel: 45,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta 16 de ataque físico e 32 de acerto.",
                necessaryLevel: 49,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta 18 de ataque físico e 36 de acerto.",
                necessaryLevel: 53,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta 20 de ataque físico e 40 de acerto.",
                necessaryLevel: 57,
            },
        ],
    },
    {
        logoId: 10,
        name: "Corpo Draconiano",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta 145 da sua vida máxima e recupera 105% da sua regeneração padrão de vida mesmo em combate a cada 8 segundos.",
                necessaryLevel: 23,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta 290 da sua vida máxima e recupera 110% da sua regeneração padrão de vida mesmo em combate a cada 8 segundos.",
                necessaryLevel: 27,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta 435 da sua vida máxima e recupera 115% da sua regeneração padrão de vida mesmo em combate a cada 8 segundos.",
                necessaryLevel: 31,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta 580 da sua vida máxima e recupera 120% da sua regeneração padrão de vida mesmo em combate a cada 8 segundos.",
                necessaryLevel: 35,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta 725 da sua vida máxima e recupera 125% da sua regeneração padrão de vida mesmo em combate a cada 8 segundos.",
                necessaryLevel: 39,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta 870 da sua vida máxima e recupera 130% da sua regeneração padrão de vida mesmo em combate a cada 8 segundos.",
                necessaryLevel: 43,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta 1015 da sua vida máxima e recupera 135% da sua regeneração padrão de vida mesmo em combate a cada 8 segundos.",
                necessaryLevel: 47,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta 1160 da sua vida máxima e recupera 140% da sua regeneração padrão de vida mesmo em combate a cada 8 segundos.",
                necessaryLevel: 51,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta 1305 da sua vida máxima e recupera 145% da sua regeneração padrão de vida mesmo em combate a cada 8 segundos.",
                necessaryLevel: 55,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta 1450 da sua vida máxima e recupera 150% da sua regeneração padrão de vida mesmo em combate a cada 8 segundos.",
                necessaryLevel: 59,
            },
        ],
    },
    {
        logoId: 11,
        name: "Cançao da Bravura",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 117,
                cast: 0,
                info:
                    "Aumenta 3 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 25,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 141,
                cast: 0,
                info:
                    "Aumenta 6 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 29,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 170,
                cast: 0,
                info:
                    "Aumenta 9 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 33,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 203,
                cast: 0,
                info:
                    "Aumenta 12 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 37,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 240,
                cast: 0,
                info:
                    "Aumenta 15 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 41,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 281,
                cast: 0,
                info:
                    "Aumenta 18 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 45,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 327,
                cast: 0,
                info:
                    "Aumenta 21 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 49,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 375,
                cast: 0,
                info:
                    "Aumenta 24 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 53,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 431,
                cast: 0,
                info:
                    "Aumenta 27 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 57,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 486,
                cast: 0,
                info:
                    "Aumenta 30 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 61,
            },
            {
                level: 11,
                cooldown: 12,
                mp: 540,
                cast: 0,
                info:
                    "Aumenta 33 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 65,
            },
            {
                level: 12,
                cooldown: 12,
                mp: 602,
                cast: 0,
                info:
                    "Aumenta 36 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 69,
            },
            {
                level: 13,
                cooldown: 12,
                mp: 669,
                cast: 0,
                info:
                    "Aumenta 39 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 73,
            },
            {
                level: 14,
                cooldown: 12,
                mp: 738,
                cast: 0,
                info:
                    "Aumenta 42 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 77,
            },
            {
                level: 15,
                cooldown: 12,
                mp: 810,
                cast: 0,
                info:
                    "Aumenta 45 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 81,
            },
            {
                level: 16,
                cooldown: 12,
                mp: 890,
                cast: 0,
                info:
                    "Aumenta 48 de Força, Agilidade e Inteligência do seu grupo durante 60 minutos.",
                necessaryLevel: 85,
            },
        ],
    },
    {
        logoId: 12,
        name: "Área de Impacto",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 139,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 214 de dano físico e reduzindo em 20 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 27,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 167,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 257 de dano físico e reduzindo em 22 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 31,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 203,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 313 de dano físico e reduzindo em 24 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 35,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 246,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 378 de dano físico e reduzindo em 26 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 39,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 290,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 446 de dano físico e reduzindo em 28 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 43,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 343,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 527 de dano físico e reduzindo em 30 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 47,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 399,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 614 de dano físico e reduzindo em 32 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 51,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 462,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 711 de dano físico e reduzindo em 34 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 55,
            },
            {
                level: 9,
                cooldown: 20,
                mp: 536,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 814 de dano físico e reduzindo em 36 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 59,
            },
            {
                level: 10,
                cooldown: 20,
                mp: 603,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 927 de dano físico e reduzindo em 38 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 63,
            },
            {
                level: 11,
                cooldown: 20,
                mp: 677,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 1042 de dano físico e reduzindo em 40 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 67,
            },
            {
                level: 12,
                cooldown: 20,
                mp: 761,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 1170 de dano físico e reduzindo em 42 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 71,
            },
            {
                level: 13,
                cooldown: 20,
                mp: 853,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 1312 de dano físico e reduzindo em 44 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 75,
            },
            {
                level: 14,
                cooldown: 20,
                mp: 948,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 1458 de dano físico e reduzindo em 46 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 79,
            },
            {
                level: 15,
                cooldown: 20,
                mp: 1053,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 1620 de dano físico e reduzindo em 48 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 83,
            },
            {
                level: 16,
                cooldown: 20,
                mp: 1170,
                cast: 0,
                info:
                    "Golpeia o chão em uma área de 5 metros causando 1800 de dano físico e reduzindo em 50 a velocidade de movimento dos alvos atingidos durante 6 segundos.",
                necessaryLevel: 87,
            },
        ],
    },
    {
        logoId: 13,
        name: "Canção da Guerra",
        levelsInfo: [
            {
                level: 1,
                cooldown: 60,
                mp: 103,
                cast: 0,
                info:
                    "Atordoa durante 1 segundo todos os alvos em uma área de 6 metros causando 240 de dano físico.",
                necessaryLevel: 32,
            },
            {
                level: 2,
                cooldown: 60,
                mp: 125,
                cast: 0,
                info:
                    "Atordoa durante 1 segundo todos os alvos em uma área de 6 metros causando 290 de dano físico.",
                necessaryLevel: 36,
            },
            {
                level: 3,
                cooldown: 60,
                mp: 151,
                cast: 0,
                info:
                    "Atordoa durante 2 segundos todos os alvos em uma área de 6 metros causando 350 de dano físico.",
                necessaryLevel: 40,
            },
            {
                level: 4,
                cooldown: 60,
                mp: 178,
                cast: 0,
                info:
                    "Atordoa durante 2 segundos todos os alvos em uma área de 6 metros causando 414 de dano físico.",
                necessaryLevel: 44,
            },
            {
                level: 5,
                cooldown: 60,
                mp: 209,
                cast: 0,
                info:
                    "Atordoa durante 3 segundos todos os alvos em uma área de 6 metros causando 488 de dano físico.",
                necessaryLevel: 48,
            },
            {
                level: 6,
                cooldown: 60,
                mp: 243,
                cast: 0,
                info:
                    "Atordoa durante 3 segundos todos os alvos em uma área de 6 metros causando 566 de dano físico.",
                necessaryLevel: 52,
            },
            {
                level: 7,
                cooldown: 60,
                mp: 281,
                cast: 0,
                info:
                    "Atordoa durante 4 segundos todos os alvos em uma área de 6 metros causando 656 de dano físico.",
                necessaryLevel: 56,
            },
            {
                level: 8,
                cooldown: 60,
                mp: 323,
                cast: 0,
                info:
                    "Atordoa durante 4 segundos todos os alvos em uma área de 6 metros causando 750 de dano físico.",
                necessaryLevel: 60,
            },
            {
                level: 9,
                cooldown: 60,
                mp: 364,
                cast: 0,
                info:
                    "Atordoa durante 5 segundos todos os alvos em uma área de 6 metros causando 848 de dano físico.",
                necessaryLevel: 64,
            },
            {
                level: 10,
                cooldown: 60,
                mp: 409,
                cast: 0,
                info:
                    "Atordoa durante 5 segundos todos os alvos em uma área de 6 metros causando 952 de dano físico.",
                necessaryLevel: 68,
            },
        ],
    },
    {
        logoId: 14,
        name: "Despertar",
        levelsInfo: [
            {
                level: 1,
                cooldown: 44,
                mp: 118,
                cast: 0,
                info:
                    "Recupera 2% da vida máxima por segundo durante 10 segundos removendo uma maldição e aumenta a chance de resistir a redução de velocidade de movimento e imobilização em 23%. Necessário a habilidade Fúria ativada no nível 1 ou superior.",
                necessaryLevel: 34,
            },
            {
                level: 2,
                cooldown: 44,
                mp: 141,
                cast: 0,
                info:
                    "Recupera 2% da vida máxima por segundo durante 10 segundos removendo uma maldição e aumenta a chance de resistir a redução de velocidade de movimento e imobilização em 26%. Necessário a habilidade Fúria ativada no nível 2 ou superior.",
                necessaryLevel: 38,
            },
            {
                level: 3,
                cooldown: 44,
                mp: 166,
                cast: 0,
                info:
                    "Recupera 2% da vida máxima por segundo durante 10 segundos removendo uma maldição e aumenta a chance de resistir a redução de velocidade de movimento e imobilização em 29%. Necessário a habilidade Fúria ativada no nível 3 ou superior.",
                necessaryLevel: 42,
            },
            {
                level: 4,
                cooldown: 44,
                mp: 194,
                cast: 0,
                info:
                    "Recupera 2% da vida máxima por segundo durante 10 segundos removendo uma maldição e aumenta a chance de resistir a redução de velocidade de movimento e imobilização em 32%. Necessário a habilidade Fúria ativada no nível 4 ou superior.",
                necessaryLevel: 46,
            },
            {
                level: 5,
                cooldown: 44,
                mp: 226,
                cast: 0,
                info:
                    "Recupera 3% da vida máxima por segundo durante 10 segundos removendo uma maldição e aumenta a chance de resistir a redução de velocidade de movimento e imobilização em 35%. Necessário a habilidade Fúria ativada no nível 5 ou superior.",
                necessaryLevel: 50,
            },
            {
                level: 6,
                cooldown: 44,
                mp: 259,
                cast: 0,
                info:
                    "Recupera 3% da vida máxima por segundo durante 10 segundos removendo uma maldição e aumenta a chance de resistir a redução de velocidade de movimento e imobilização em 38%. Necessário a habilidade Fúria ativada no nível 6 ou superior.",
                necessaryLevel: 54,
            },
            {
                level: 7,
                cooldown: 44,
                mp: 297,
                cast: 0,
                info:
                    "Recupera 3% da vida máxima por segundo durante 10 segundos removendo uma maldição e aumenta a chance de resistir a redução de velocidade de movimento e imobilização em 41%. Necessário a habilidade Fúria ativada no nível 7 ou superior.",
                necessaryLevel: 58,
            },
            {
                level: 8,
                cooldown: 44,
                mp: 333,
                cast: 0,
                info:
                    "Recupera 3% da vida máxima por segundo durante 10 segundos removendo uma maldição e aumenta a chance de resistir a redução de velocidade de movimento e imobilização em 44%. Necessário a habilidade Fúria ativada no nível 8 ou superior.",
                necessaryLevel: 62,
            },
            {
                level: 9,
                cooldown: 44,
                mp: 370,
                cast: 0,
                info:
                    "Recupera 4% da vida máxima por segundo durante 10 segundos removendo uma maldição e aumenta a chance de resistir a redução de velocidade de movimento e imobilização em 47%. Necessário a habilidade Fúria ativada no nível 9 ou superior.",
                necessaryLevel: 66,
            },
            {
                level: 10,
                cooldown: 44,
                mp: 412,
                cast: 0,
                info:
                    "Recupera 4% da vida máxima por segundo durante 10 segundos removendo uma maldição e aumenta a chance de resistir a redução de velocidade de movimento e imobilização em 50%. Necessário a habilidade Fúria ativada no nível 10 ou superior.",
                necessaryLevel: 70,
            },
        ],
    },
    {
        logoId: 15,
        name: "Estocada",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 108,
                cast: 0,
                info:
                    "Ataca o inimigo causando 114 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 60% menos cura.",
                necessaryLevel: 36,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 130,
                cast: 0,
                info:
                    "Ataca o inimigo causando 138 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 62% menos cura.",
                necessaryLevel: 40,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 157,
                cast: 0,
                info:
                    "Ataca o inimigo causando 166 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 64% menos cura.",
                necessaryLevel: 44,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 191,
                cast: 0,
                info:
                    "Ataca o inimigo causando 202 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 66% menos cura.",
                necessaryLevel: 48,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 231,
                cast: 0,
                info:
                    "Ataca o inimigo causando 244 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 68% menos cura.",
                necessaryLevel: 52,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 276,
                cast: 0,
                info:
                    "Ataca o inimigo causando 292 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 70% menos cura.",
                necessaryLevel: 56,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 325,
                cast: 0,
                info:
                    "Ataca o inimigo causando 344 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 72% menos cura.",
                necessaryLevel: 60,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 384,
                cast: 0,
                info:
                    "Ataca o inimigo causando 406 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 74% menos cura.",
                necessaryLevel: 64,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 444,
                cast: 0,
                info:
                    "Remove 1 benefício e ataca o inimigo causando 470 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 76% menos cura.",
                necessaryLevel: 68,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 514,
                cast: 0,
                info:
                    "Remove 1 benefício e ataca o inimigo causando 544 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 78% menos cura.",
                necessaryLevel: 72,
            },
            {
                level: 11,
                cooldown: 6,
                mp: 586,
                cast: 0,
                info:
                    "Remove 1 benefício e ataca o inimigo causando 620 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 80% menos cura.",
                necessaryLevel: 76,
            },
            {
                level: 12,
                cooldown: 6,
                mp: 660,
                cast: 0,
                info:
                    "Remove 1 benefício e ataca o inimigo causando 698 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 82% menos cura.",
                necessaryLevel: 80,
            },
            {
                level: 13,
                cooldown: 6,
                mp: 743,
                cast: 0,
                info:
                    "Remove 1 benefício e ataca o inimigo causando 786 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 84% menos cura.",
                necessaryLevel: 84,
            },
            {
                level: 14,
                cooldown: 6,
                mp: 835,
                cast: 0,
                info:
                    "Remove 1 benefício e ataca o inimigo causando 884 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 86% menos cura.",
                necessaryLevel: 88,
            },
            {
                level: 15,
                cooldown: 6,
                mp: 930,
                cast: 0,
                info:
                    "Remove 1 benefício e ataca o inimigo causando 984 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 88% menos cura.",
                necessaryLevel: 92,
            },
            {
                level: 16,
                cooldown: 6,
                mp: 1032,
                cast: 0,
                info:
                    "Remove 2 benefícios e ataca o inimigo causando 1092 de dano físico e o faz sangrar por 6 segundos. Inimigos com sangramento recebem 90% menos cura.",
                necessaryLevel: 96,
            },
        ],
    },
    {
        logoId: 16,
        name: "Canção da Defesa",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 212,
                cast: 0,
                info:
                    "Aumenta 131 de defesa física e 99 de defesa mágica aumentando em 2 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 38,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 250,
                cast: 0,
                info:
                    "Aumenta 155 de defesa física e 117 de defesa mágica aumentando em 2 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 42,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 292,
                cast: 0,
                info:
                    "Aumenta 183 de defesa física e 138 de defesa mágica aumentando em 3 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 46,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 339,
                cast: 0,
                info:
                    "Aumenta 219 de defesa física e 165 de defesa mágica aumentando em 3 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 50,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 388,
                cast: 0,
                info:
                    "Aumenta 259 de defesa física e 196 de defesa mágica aumentando em 4 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 54,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 445,
                cast: 0,
                info:
                    "Aumenta 300 de defesa física e 228 de defesa mágica aumentando em 4 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 58,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 499,
                cast: 0,
                info:
                    "Aumenta 343 de defesa física e 260 de defesa mágica aumentando em 5 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 62,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 555,
                cast: 0,
                info:
                    "Aumenta 386 de defesa física e 295 de defesa mágica aumentando em 5 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 66,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 617,
                cast: 0,
                info:
                    "Aumenta 433 de defesa física e 331 de defesa mágica aumentando em 6 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 70,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 687,
                cast: 0,
                info:
                    "Aumenta 487 de defesa física e 373 de defesa mágica aumentando em 6 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 74,
            },
            {
                level: 11,
                cooldown: 12,
                mp: 755,
                cast: 0,
                info:
                    "Aumenta 550 de defesa física e 422 de defesa mágica aumentando em 7 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 78,
            },
            {
                level: 12,
                cooldown: 12,
                mp: 830,
                cast: 0,
                info:
                    "Aumenta 620 de defesa física e 476 de defesa mágica aumentando em 7 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 82,
            },
            {
                level: 13,
                cooldown: 12,
                mp: 911,
                cast: 0,
                info:
                    "Aumenta 701 de defesa física e 541 de defesa mágica aumentando em 8 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 86,
            },
            {
                level: 14,
                cooldown: 12,
                mp: 1001,
                cast: 0,
                info:
                    "Aumenta 791 de defesa física e 611 de defesa mágica aumentando em 8 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 90,
            },
            {
                level: 15,
                cooldown: 12,
                mp: 1100,
                cast: 0,
                info:
                    "Aumenta 892 de defesa física e 689 de defesa mágica aumentando em 9 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 94,
            },
            {
                level: 16,
                cooldown: 12,
                mp: 1208,
                cast: 0,
                info:
                    "Aumenta 1007 de defesa física e 782 de defesa mágica aumentando em 10 a resistência a estados anormais de todos os membros do grupo durante 60 minutos.",
                necessaryLevel: 98,
            },
        ],
    },
    {
        logoId: 17,
        name: "Ferida Mortal",
        levelsInfo: [
            {
                level: 1,
                cooldown: 30,
                mp: 267,
                cast: 0,
                info:
                    "Fere seu alvo causando 513 de dano físico e o impede de usar habilidades por 6 segundos.",
                necessaryLevel: 40,
            },
            {
                level: 2,
                cooldown: 30,
                mp: 316,
                cast: 0,
                info:
                    "Fere seu alvo causando 607 de dano físico e o impede de usar habilidades por 6 segundos.",
                necessaryLevel: 44,
            },
            {
                level: 3,
                cooldown: 30,
                mp: 372,
                cast: 0,
                info:
                    "Fere seu alvo causando 715 de dano físico e o impede de usar habilidades por 6 segundos.",
                necessaryLevel: 48,
            },
            {
                level: 4,
                cooldown: 30,
                mp: 431,
                cast: 0,
                info:
                    "Fere seu alvo causando 829 de dano físico e o impede de usar habilidades por 7 segundos.",
                necessaryLevel: 52,
            },
            {
                level: 5,
                cooldown: 30,
                mp: 500,
                cast: 0,
                info:
                    "Fere seu alvo causando 961 de dano físico e o impede de usar habilidades por 7 segundos.",
                necessaryLevel: 56,
            },
            {
                level: 6,
                cooldown: 30,
                mp: 571,
                cast: 0,
                info:
                    "Fere seu alvo causando 1098 de dano físico e o impede de usar habilidades por 7 segundos.",
                necessaryLevel: 60,
            },
            {
                level: 7,
                cooldown: 30,
                mp: 646,
                cast: 0,
                info:
                    "Fere seu alvo causando 1242 de dano físico e o impede de usar habilidades por 8 segundos.",
                necessaryLevel: 64,
            },
            {
                level: 8,
                cooldown: 30,
                mp: 725,
                cast: 0,
                info:
                    "Fere seu alvo causando 1395 de dano físico e o impede de usar habilidades por 8 segundos.",
                necessaryLevel: 68,
            },
            {
                level: 9,
                cooldown: 30,
                mp: 816,
                cast: 0,
                info:
                    "Fere seu alvo causando 1570 de dano físico e o impede de usar habilidades por 8 segundos.",
                necessaryLevel: 72,
            },
            {
                level: 10,
                cooldown: 30,
                mp: 913,
                cast: 0,
                info:
                    "Fere seu alvo causando 1755 de dano físico e o impede de usar habilidades por 9 segundos.",
                necessaryLevel: 76,
            },
            {
                level: 11,
                cooldown: 30,
                mp: 1013,
                cast: 0,
                info:
                    "Fere seu alvo causando 1948 de dano físico e o impede de usar habilidades por 9 segundos.",
                necessaryLevel: 80,
            },
            {
                level: 12,
                cooldown: 30,
                mp: 1126,
                cast: 0,
                info:
                    "Fere seu alvo causando 2165 de dano físico e o impede de usar habilidades por 9 segundos.",
                necessaryLevel: 84,
            },
            {
                level: 13,
                cooldown: 30,
                mp: 1251,
                cast: 0,
                info:
                    "Fere seu alvo causando 2406 de dano físico e o impede de usar habilidades por 10 segundos.",
                necessaryLevel: 88,
            },
            {
                level: 14,
                cooldown: 30,
                mp: 1377,
                cast: 0,
                info:
                    "Fere seu alvo causando 2649 de dano físico e o impede de usar habilidades por 10 segundos.",
                necessaryLevel: 92,
            },
            {
                level: 15,
                cooldown: 30,
                mp: 1515,
                cast: 0,
                info:
                    "Fere seu alvo causando 2915 de dano físico e o impede de usar habilidades por 10 segundos.",
                necessaryLevel: 96,
            },
            {
                level: 16,
                cooldown: 30,
                mp: 1668,
                cast: 0,
                info:
                    "Fere seu alvo causando 3208 de dano físico e o impede de usar habilidades por 10 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 18,
        name: "Salto de Impacto",
        levelsInfo: [
            {
                level: 1,
                cooldown: 90,
                mp: 357,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 700 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 40,
            },
            {
                level: 2,
                cooldown: 90,
                mp: 422,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 828 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 44,
            },
            {
                level: 3,
                cooldown: 90,
                mp: 497,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 976 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 48,
            },
            {
                level: 4,
                cooldown: 90,
                mp: 577,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 1132 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 52,
            },
            {
                level: 5,
                cooldown: 90,
                mp: 668,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 1312 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 56,
            },
            {
                level: 6,
                cooldown: 90,
                mp: 765,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 1500 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 60,
            },
            {
                level: 7,
                cooldown: 90,
                mp: 865,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 1696 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 64,
            },
            {
                level: 8,
                cooldown: 90,
                mp: 970,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 1904 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 68,
            },
            {
                level: 9,
                cooldown: 90,
                mp: 1092,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 2144 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 72,
            },
            {
                level: 10,
                cooldown: 90,
                mp: 1221,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 2396 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 76,
            },
            {
                level: 11,
                cooldown: 90,
                mp: 1355,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 2660 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 80,
            },
            {
                level: 12,
                cooldown: 90,
                mp: 1507,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 2956 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 84,
            },
            {
                level: 13,
                cooldown: 90,
                mp: 1673,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 3284 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 88,
            },
            {
                level: 14,
                cooldown: 90,
                mp: 1842,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 3616 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 92,
            },
            {
                level: 15,
                cooldown: 90,
                mp: 2028,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 3980 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 96,
            },
            {
                level: 16,
                cooldown: 90,
                mp: 2232,
                cast: 0,
                info:
                    "Seleciona uma área e salta para o local causando 4380 de dano físico em todos os alvos em uma área de 5 metros.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 19,
        name: "Canção do Medo",
        levelsInfo: [
            {
                level: 1,
                cooldown: 60,
                mp: 351,
                cast: 0,
                info:
                    "Apavora os inimigos em um raio de 6 metros e os submetem a um estado de Medo que dura 6 segundos. Alvos sob esse efeito tem 95% de chance de se libertarem ao serem atacados e recebem uma penalidade na velocidade de movimento.",
                necessaryLevel: 51,
            },
            {
                level: 2,
                cooldown: 58,
                mp: 402,
                cast: 0,
                info:
                    "Apavora os inimigos em um raio de 6 metros e os submetem a um estado de Medo que dura 7 segundos. Alvos sob esse efeito tem 90% de chance de se libertarem ao serem atacados e recebem uma penalidade na velocidade de movimento.",
                necessaryLevel: 55,
            },
            {
                level: 3,
                cooldown: 56,
                mp: 455,
                cast: 0,
                info:
                    "Apavora os inimigos em um raio de 6 metros e os submetem a um estado de Medo que dura 8 segundos. Alvos sob esse efeito tem 85% de chance de se libertarem ao serem atacados e recebem uma penalidade na velocidade de movimento.",
                necessaryLevel: 59,
            },
            {
                level: 4,
                cooldown: 54,
                mp: 512,
                cast: 0,
                info:
                    "Apavora os inimigos em um raio de 6 metros e os submetem a um estado de Medo que dura 9 segundos. Alvos sob esse efeito tem 80% de chance de se libertarem ao serem atacados e recebem uma penalidade na velocidade de movimento.",
                necessaryLevel: 63,
            },
            {
                level: 5,
                cooldown: 52,
                mp: 570,
                cast: 0,
                info:
                    "Apavora os inimigos em um raio de 6 metros e os submetem a um estado de Medo que dura 10 segundos. Alvos sob esse efeito tem 75% de chance de se libertarem ao serem atacados e recebem uma penalidade na velocidade de movimento.",
                necessaryLevel: 67,
            },
            {
                level: 6,
                cooldown: 50,
                mp: 634,
                cast: 0,
                info:
                    "Apavora os inimigos em um raio de 6 metros e os submetem a um estado de Medo que dura 11 segundos. Alvos sob esse efeito tem 70% de chance de se libertarem ao serem atacados e recebem uma penalidade na velocidade de movimento.",
                necessaryLevel: 71,
            },
            {
                level: 7,
                cooldown: 48,
                mp: 703,
                cast: 0,
                info:
                    "Apavora os inimigos em um raio de 6 metros e os submetem a um estado de Medo que dura 12 segundos. Alvos sob esse efeito tem 65% de chance de se libertarem ao serem atacados e recebem uma penalidade na velocidade de movimento.",
                necessaryLevel: 75,
            },
            {
                level: 8,
                cooldown: 46,
                mp: 773,
                cast: 0,
                info:
                    "Apavora os inimigos em um raio de 6 metros e os submetem a um estado de Medo que dura 13 segundos. Alvos sob esse efeito tem 60% de chance de se libertarem ao serem atacados e recebem uma penalidade na velocidade de movimento.",
                necessaryLevel: 79,
            },
            {
                level: 9,
                cooldown: 44,
                mp: 850,
                cast: 0,
                info:
                    "Apavora os inimigos em um raio de 6 metros e os submetem a um estado de Medo que dura 14 segundos. Alvos sob esse efeito tem 55% de chance de se libertarem ao serem atacados e recebem uma penalidade na velocidade de movimento.",
                necessaryLevel: 83,
            },
            {
                level: 10,
                cooldown: 40,
                mp: 933,
                cast: 0,
                info:
                    "Apavora os inimigos em um raio de 6 metros e os submetem a um estado de Medo que dura 15 segundos. Alvos sob esse efeito tem 50% de chance de se libertarem ao serem atacados e recebem uma penalidade na velocidade de movimento.",
                necessaryLevel: 87,
            },
        ],
    },
    {
        logoId: 20,
        name: "Inspirar Coragem",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Reduz o tempo de recarga de todas as habilidades em 2%.",
                necessaryLevel: 55,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Reduz o tempo de recarga de todas as habilidades em 4%.",
                necessaryLevel: 59,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Reduz o tempo de recarga de todas as habilidades em 6%.",
                necessaryLevel: 63,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Reduz o tempo de recarga de todas as habilidades em 8%.",
                necessaryLevel: 67,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o tempo de recarga de todas as habilidades em 10%.",
                necessaryLevel: 71,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o tempo de recarga de todas as habilidades em 12%.",
                necessaryLevel: 75,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o tempo de recarga de todas as habilidades em 14%.",
                necessaryLevel: 79,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o tempo de recarga de todas as habilidades em 16%.",
                necessaryLevel: 83,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o tempo de recarga de todas as habilidades em 18%.",
                necessaryLevel: 87,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o tempo de recarga de todas as habilidades em 20%.",
                necessaryLevel: 91,
            },
        ],
    },
    {
        logoId: 21,
        name: "Lâmina Carregada",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 1066,
                cast: 2,
                info:
                    "Concentra grande quantidade de mana na ponta da espada e dispersa essa energia atingindo o alvo e a sua volta em um raio de 6 metros causando 2342 de dano físico adicional.",
                necessaryLevel: 59,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 1200,
                cast: 2,
                info:
                    "Concentra grande quantidade de mana na ponta da espada e dispersa essa energia atingindo o alvo e a sua volta em um raio de 6 metros causando 2637 de dano físico adicional.",
                necessaryLevel: 63,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 1348,
                cast: 2,
                info:
                    "Concentra grande quantidade de mana na ponta da espada e dispersa essa energia atingindo o alvo e a sua volta em um raio de 6 metros causando 2963 de dano físico adicional.",
                necessaryLevel: 67,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 1514,
                cast: 2,
                info:
                    "Concentra grande quantidade de mana na ponta da espada e dispersa essa energia atingindo o alvo e a sua volta em um raio de 6 metros causando 3328 de dano físico adicional.",
                necessaryLevel: 71,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 1698,
                cast: 2,
                info:
                    "Concentra grande quantidade de mana na ponta da espada e dispersa essa energia atingindo o alvo e a sua volta em um raio de 6 metros causando 3731 de dano físico adicional.",
                necessaryLevel: 75,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 1887,
                cast: 2,
                info:
                    "Concentra grande quantidade de mana na ponta da espada e dispersa essa energia atingindo o alvo e a sua volta em um raio de 6 metros causando 4147 de dano físico adicional.",
                necessaryLevel: 79,
            },
            {
                level: 7,
                cooldown: 120,
                mp: 2097,
                cast: 2,
                info:
                    "Concentra grande quantidade de mana na ponta da espada e dispersa essa energia atingindo o alvo e a sua volta em um raio de 6 metros causando 4608 de dano físico adicional.",
                necessaryLevel: 83,
            },
            {
                level: 8,
                cooldown: 120,
                mp: 2330,
                cast: 2,
                info:
                    "Concentra grande quantidade de mana na ponta da espada e dispersa essa energia atingindo o alvo e a sua volta em um raio de 6 metros causando 5120 de dano físico adicional.",
                necessaryLevel: 87,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 2586,
                cast: 2,
                info:
                    "Concentra grande quantidade de mana na ponta da espada e dispersa essa energia atingindo o alvo e a sua volta em um raio de 6 metros causando 5683 de dano físico adicional.",
                necessaryLevel: 91,
            },
            {
                level: 10,
                cooldown: 120,
                mp: 2871,
                cast: 2,
                info:
                    "Concentra grande quantidade de mana na ponta da espada e dispersa essa energia atingindo o alvo e a sua volta em um raio de 6 metros causando 6310 de dano físico adicional.",
                necessaryLevel: 95,
            },
            {
                level: 11,
                cooldown: 120,
                mp: 3189,
                cast: 2,
                info:
                    "Concentra grande quantidade de mana na ponta da espada e dispersa essa energia atingindo o alvo e a sua volta em um raio de 6 metros causando 7008 de dano físico adicional.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 22,
        name: "Investida Mortal",
        levelsInfo: [
            {
                level: 1,
                cooldown: 40,
                mp: 424,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 12 metros atingindo o alvo e a sua volta causando 931 de dano físico, reduzindo em 20 a velocidade de movimento e em 5 as resistências a crítico durante 6 segundos.",
                necessaryLevel: 61,
            },
            {
                level: 2,
                cooldown: 39,
                mp: 476,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 12 metros atingindo o alvo e a sua volta causando 1046 de dano físico, reduzindo em 22 a velocidade de movimento e em 7 as resistências a crítico durante 6 segundos.",
                necessaryLevel: 65,
            },
            {
                level: 3,
                cooldown: 38,
                mp: 536,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 12 metros atingindo o alvo e a sua volta causando 1178 de dano físico, reduzindo em 24 a velocidade de movimento e em 9 as resistências a crítico durante 6 segundos.",
                necessaryLevel: 69,
            },
            {
                level: 4,
                cooldown: 37,
                mp: 603,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 12 metros atingindo o alvo e a sua volta causando 1325 de dano físico, reduzindo em 26 a velocidade de movimento e em 11 as resistências a crítico durante 6 segundos.",
                necessaryLevel: 73,
            },
            {
                level: 5,
                cooldown: 36,
                mp: 672,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 12 metros atingindo o alvo e a sua volta causando 1476 de dano físico, reduzindo em 28 a velocidade de movimento e em 13 as resistências a crítico durante 6 segundos.",
                necessaryLevel: 77,
            },
            {
                level: 6,
                cooldown: 35,
                mp: 746,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 12 metros atingindo o alvo e a sua volta causando 1639 de dano físico, reduzindo em 30 a velocidade de movimento e em 15 as resistências a crítico durante 6 segundos.",
                necessaryLevel: 81,
            },
            {
                level: 7,
                cooldown: 34,
                mp: 828,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 12 metros atingindo o alvo e a sua volta causando 1819 de dano físico, reduzindo em 32 a velocidade de movimento e em 17 as resistências a crítico durante 6 segundos.",
                necessaryLevel: 85,
            },
            {
                level: 8,
                cooldown: 33,
                mp: 920,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 12 metros atingindo o alvo e a sua volta causando 2021 de dano físico, reduzindo em 34 a velocidade de movimento e em 19 as resistências a crítico durante 6 segundos.",
                necessaryLevel: 89,
            },
            {
                level: 9,
                cooldown: 32,
                mp: 1021,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 12 metros atingindo o alvo e a sua volta causando 2244 de dano físico, reduzindo em 36 a velocidade de movimento e em 21 as resistências a crítico durante 6 segundos.",
                necessaryLevel: 93,
            },
            {
                level: 10,
                cooldown: 30,
                mp: 1135,
                cast: 0,
                info:
                    "Avança em direção ao alvo até uma distância de 12 metros atingindo o alvo e a sua volta causando 2494 de dano físico, reduzindo em 38 a velocidade de movimento e em 25 as resistências a crítico durante 6 segundos.",
                necessaryLevel: 97,
            },
        ],
    },
    {
        logoId: 23,
        name: "Instinto de Batalha",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o dano recebido dos ataques de área em 30% e aumenta 1 de crítico.",
                necessaryLevel: 65,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o dano recebido dos ataques de área em 32% e aumenta 2 de crítico.",
                necessaryLevel: 69,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o dano recebido dos ataques de área em 34% e aumenta 3 de crítico.",
                necessaryLevel: 73,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o dano recebido dos ataques de área em 36% e aumenta 4 de crítico.",
                necessaryLevel: 77,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o dano recebido dos ataques de área em 38% e aumenta 5 de crítico.",
                necessaryLevel: 81,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o dano recebido dos ataques de área em 40% e aumenta 6 de crítico.",
                necessaryLevel: 85,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o dano recebido dos ataques de área em 42% e aumenta 7 de crítico.",
                necessaryLevel: 89,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o dano recebido dos ataques de área em 44% e aumenta 8 de crítico.",
                necessaryLevel: 93,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o dano recebido dos ataques de área em 46% e aumenta 9 de crítico.",
                necessaryLevel: 97,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Reduz o dano recebido dos ataques de área em 50% e aumenta 10 de crítico.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 24,
        name: "Mestre da Espada",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 802,
                cast: 2,
                info:
                    "Sua espada passa a devorar toda a sua mana e aumenta em 50% sua perfuração física e 30 de dano crítico. Sua regeneração automática de mana será interrompida e você passa a perder 10 de mana por segundo durante 10 minutos ou após sua mana esgotar.",
                necessaryLevel: 69,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 892,
                cast: 2,
                info:
                    "Sua espada passa a devorar toda a sua mana e aumenta em 52% sua perfuração física e 33 de dano crítico. Sua regeneração automática de mana será interrompida e você passa a perder 11 de mana por segundo durante 10 minutos ou após sua mana esgotar.",
                necessaryLevel: 73,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 983,
                cast: 2,
                info:
                    "Sua espada passa a devorar toda a sua mana e aumenta em 54% sua perfuração física e 36 de dano crítico. Sua regeneração automática de mana será interrompida e você passa a perder 12 de mana por segundo durante 10 minutos ou após sua mana esgotar.",
                necessaryLevel: 77,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 1080,
                cast: 2,
                info:
                    "Sua espada passa a devorar toda a sua mana e aumenta em 56% sua perfuração física e 39 de dano crítico. Sua regeneração automática de mana será interrompida e você passa a perder 13 de mana por segundo durante 10 minutos ou após sua mana esgotar.",
                necessaryLevel: 81,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 1187,
                cast: 2,
                info:
                    "Sua espada passa a devorar toda a sua mana e aumenta em 57% sua perfuração física e 42 de dano crítico. Sua regeneração automática de mana será interrompida e você passa a perder 14 de mana por segundo durante 10 minutos ou após sua mana esgotar.",
                necessaryLevel: 85,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 1304,
                cast: 2,
                info:
                    "Sua espada passa a devorar toda a sua mana e aumenta em 58% sua perfuração física e 45 de dano crítico. Sua regeneração automática de mana será interrompida e você passa a perder 15 de mana por segundo durante 10 minutos ou após sua mana esgotar.",
                necessaryLevel: 89,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 1432,
                cast: 2,
                info:
                    "Sua espada passa a devorar toda a sua mana e aumenta em 59% sua perfuração física e 48 de dano crítico. Sua regeneração automática de mana será interrompida e você passa a perder 16 de mana por segundo durante 10 minutos ou após sua mana esgotar.",
                necessaryLevel: 93,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 1572,
                cast: 2,
                info:
                    "Sua espada passa a devorar toda a sua mana e aumenta em 60% sua perfuração física e 51 de dano crítico. Sua regeneração automática de mana será interrompida e você passa a perder 17 de mana por segundo durante 10 minutos ou após sua mana esgotar.",
                necessaryLevel: 97,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 1648,
                cast: 2,
                info:
                    "Sua espada passa a devorar toda a sua mana e aumenta em 60% sua perfuração física e 55 de dano crítico. Sua regeneração automática de mana será interrompida e você passa a perder 18 de mana por segundo durante 10 minutos ou após sua mana esgotar.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 25,
        name: "Pancada de Sangue",
        levelsInfo: [
            {
                level: 1,
                cooldown: 16,
                mp: 406,
                cast: 0,
                info:
                    "Desfere um golpe brutal causando 780 de dano físico e um dano extra baseado em 9% da sua vida atual. O dano final não será superior a 50% da vida máxima do usuário.",
                necessaryLevel: 71,
            },
            {
                level: 2,
                cooldown: 16,
                mp: 455,
                cast: 0,
                info:
                    "Desfere um golpe brutal causando 875 de dano físico e um dano extra baseado em 10% da sua vida atual. O dano final não será superior a 50% da vida máxima do usuário.",
                necessaryLevel: 75,
            },
            {
                level: 3,
                cooldown: 16,
                mp: 505,
                cast: 0,
                info:
                    "Desfere um golpe brutal causando 972 de dano físico e um dano extra baseado em 11% da sua vida atual. O dano final não será superior a 50% da vida máxima do usuário.",
                necessaryLevel: 79,
            },
            {
                level: 4,
                cooldown: 16,
                mp: 562,
                cast: 0,
                info:
                    "Desfere um golpe brutal causando 1080 de dano físico e um dano extra baseado em 12% da sua vida atual. O dano final não será superior a 50% da vida máxima do usuário.",
                necessaryLevel: 83,
            },
            {
                level: 5,
                cooldown: 16,
                mp: 624,
                cast: 0,
                info:
                    "Desfere um golpe brutal causando 1200 de dano físico e um dano extra baseado em 13% da sua vida atual. O dano final não será superior a 50% da vida máxima do usuário.",
                necessaryLevel: 87,
            },
            {
                level: 6,
                cooldown: 16,
                mp: 693,
                cast: 0,
                info:
                    "Desfere um golpe brutal causando 1332 de dano físico e um dano extra baseado em 14% da sua vida atual. O dano final não será superior a 50% da vida máxima do usuário.",
                necessaryLevel: 91,
            },
            {
                level: 7,
                cooldown: 16,
                mp: 769,
                cast: 0,
                info:
                    "Desfere um golpe brutal causando 1479 de dano físico e um dano extra baseado em 15% da sua vida atual. O dano final não será superior a 50% da vida máxima do usuário.",
                necessaryLevel: 95,
            },
            {
                level: 8,
                cooldown: 16,
                mp: 854,
                cast: 0,
                info:
                    "Desfere um golpe brutal causando 1643 de dano físico e um dano extra baseado em 16% da sua vida atual. O dano final não será superior a 50% da vida máxima do usuário.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 26,
        name: "Uivo da Liberdade",
        levelsInfo: [
            {
                level: 1,
                cooldown: 90,
                mp: 704,
                cast: 0,
                info:
                    "Encoraja a todos os membros do grupo removendo todas as maldições (categoria vermelha) e aumenta em 40 a resistência de estados anormais e em 15 a velocidade de movimento durante 10 segundos. O usuário recebe um benefício único que o protege das maldições (categoria vermelha) durante 10 segundos.",
                necessaryLevel: 75,
            },
            {
                level: 2,
                cooldown: 90,
                mp: 773,
                cast: 0,
                info:
                    "Encoraja a todos os membros do grupo removendo todas as maldições (categoria vermelha) e aumenta em 45 a resistência de estados anormais e em 16 a velocidade de movimento durante 11 segundos. O usuário recebe um benefício único que o protege das maldições (categoria vermelha) durante 11 segundos.",
                necessaryLevel: 79,
            },
            {
                level: 3,
                cooldown: 90,
                mp: 850,
                cast: 0,
                info:
                    "Encoraja a todos os membros do grupo removendo todas as maldições (categoria vermelha) e aumenta em 50 a resistência de estados anormais e em 17 a velocidade de movimento durante 12 segundos. O usuário recebe um benefício único que o protege das maldições (categoria vermelha) durante 12 segundos.",
                necessaryLevel: 83,
            },
            {
                level: 4,
                cooldown: 90,
                mp: 933,
                cast: 0,
                info:
                    "Encoraja a todos os membros do grupo removendo todas as maldições (categoria vermelha) e aumenta em 55 a resistência de estados anormais e em 18 a velocidade de movimento durante 13 segundos. O usuário recebe um benefício único que o protege das maldições (categoria vermelha) durante 13 segundos.",
                necessaryLevel: 87,
            },
            {
                level: 5,
                cooldown: 90,
                mp: 1025,
                cast: 0,
                info:
                    "Encoraja a todos os membros do grupo removendo todas as maldições (categoria vermelha) e aumenta em 60 a resistência de estados anormais e em 19 a velocidade de movimento durante 14 segundos. O usuário recebe um benefício único que o protege das maldições (categoria vermelha) durante 14 segundos.",
                necessaryLevel: 91,
            },
            {
                level: 6,
                cooldown: 90,
                mp: 1125,
                cast: 0,
                info:
                    "Encoraja a todos os membros do grupo removendo todas as maldições (categoria vermelha) e aumenta em 65 a resistência de estados anormais e em 20 a velocidade de movimento durante 15 segundos. O usuário recebe um benefício único que o protege das maldições (categoria vermelha) durante 15 segundos.",
                necessaryLevel: 95,
            },
            {
                level: 7,
                cooldown: 90,
                mp: 1236,
                cast: 0,
                info:
                    "Encoraja a todos os membros do grupo removendo todas as maldições (categoria vermelha) e aumenta em 70 a resistência de estados anormais e em 22 a velocidade de movimento durante 16 segundos. O usuário recebe um benefício único que o protege das maldições (categoria vermelha) durante 16 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 27,
        name: "Uivo de Sangue",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 773,
                cast: 0,
                info:
                    "Durante 40 segundos sacia a sede de sangue de todos os membros do grupo onde o dano causado será convertido em 50% de vida e 25% de mana.",
                necessaryLevel: 79,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 850,
                cast: 0,
                info:
                    "Durante 40 segundos sacia a sede de sangue de todos os membros do grupo onde o dano causado será convertido em 60% de vida e 30% de mana.",
                necessaryLevel: 83,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 933,
                cast: 0,
                info:
                    "Durante 40 segundos sacia a sede de sangue de todos os membros do grupo onde o dano causado será convertido em 70% de vida e 35% de mana.",
                necessaryLevel: 87,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 1025,
                cast: 0,
                info:
                    "Durante 40 segundos sacia a sede de sangue de todos os membros do grupo onde o dano causado será convertido em 80% de vida e 40% de mana.",
                necessaryLevel: 91,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 1125,
                cast: 0,
                info:
                    "Durante 40 segundos sacia a sede de sangue de todos os membros do grupo onde o dano causado será convertido em 90% de vida e 45% de mana.",
                necessaryLevel: 95,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 1236,
                cast: 0,
                info:
                    "Durante 40 segundos sacia a sede de sangue de todos os membros do grupo onde o dano causado será convertido em 100% de vida e 50% de mana.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 28,
        name: "Espada Sangrenta",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 1080,
                cast: 2,
                info:
                    "Aumenta 140 de ataque físico, 683 de habilidade de ataque e 20 de crítico. As habilidade passam a consumir 170% do custo da mana retirados diretamente da vida.",
                necessaryLevel: 81,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 1187,
                cast: 2,
                info:
                    "Aumenta 152 de ataque físico, 739 de habilidade de ataque e 21 de crítico. As habilidade passam a consumir 160% do custo da mana retirados diretamente da vida.",
                necessaryLevel: 85,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 1304,
                cast: 2,
                info:
                    "Aumenta 164 de ataque físico, 814 de habilidade de ataque e 22 de crítico. As habilidade passam a consumir 150% do custo da mana retirados diretamente da vida.",
                necessaryLevel: 89,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 1432,
                cast: 2,
                info:
                    "Aumenta 177 de ataque físico, 898 de habilidade de ataque e 23 de crítico. As habilidade passam a consumir 140% do custo da mana retirados diretamente da vida.",
                necessaryLevel: 93,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 1572,
                cast: 2,
                info:
                    "Aumenta 201 de ataque físico, 991 de habilidade de ataque e 24 de crítico. As habilidade passam a consumir 130% do custo da mana retirados diretamente da vida.",
                necessaryLevel: 97,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 1648,
                cast: 2,
                info:
                    "Aumenta 242 de ataque físico, 1095 de habilidade de ataque e 25 de crítico. As habilidade passam a consumir 120% do custo da mana retirados diretamente da vida.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 29,
        name: "Poder Absoluto",
        levelsInfo: [
            {
                level: 1,
                cooldown: 28,
                mp: 1560,
                cast: 0,
                info:
                    "Acerta o alvo e o que estiver a sua volta derrubando-os no chão causando 1516 de dano físico. O alvo se recompõe após 1 ataque ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 85,
            },
            {
                level: 2,
                cooldown: 28,
                mp: 1733,
                cast: 0,
                info:
                    "Acerta o alvo e o que estiver a sua volta derrubando-os no chão causando 1684 de dano físico. O alvo se recompõe após 1 ataque ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 89,
            },
            {
                level: 3,
                cooldown: 28,
                mp: 1924,
                cast: 0,
                info:
                    "Acerta o alvo e o que estiver a sua volta derrubando-os no chão causando 1870 de dano físico. O alvo se recompõe após 1 ataque ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 93,
            },
            {
                level: 4,
                cooldown: 28,
                mp: 2138,
                cast: 0,
                info:
                    "Acerta o alvo e o que estiver a sua volta derrubando-os no chão causando 2078 de dano físico. O alvo se recompõe após 1 ataque ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 97,
            },
            {
                level: 5,
                cooldown: 28,
                mp: 2253,
                cast: 0,
                info:
                    "Acerta o alvo e o que estiver a sua volta derrubando-os no chão causando 2190 de dano físico. O alvo se recompõe após 1 ataque ou após um curto período de tempo. Alvos derrubados não conseguem se esquivar de ataques.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 30,
        name: "Limite Brutal",
        levelsInfo: [
            {
                level: 1,
                cooldown: 50,
                mp: 1445,
                cast: 0,
                info:
                    "Brande sua espada causando 2054 de dano físico nos inimigos e perfura em linha reta seus inimigos aplicando sangramento por 5 segundos. Inimigos com sangramento recebem 85% menos cura.",
                necessaryLevel: 89,
            },
            {
                level: 2,
                cooldown: 50,
                mp: 1604,
                cast: 0,
                info:
                    "Brande sua espada causando 2281 de dano físico nos inimigos e perfura em linha reta seus inimigos aplicando sangramento por 5 segundos. Inimigos com sangramento recebem 90% menos cura.",
                necessaryLevel: 93,
            },
            {
                level: 3,
                cooldown: 50,
                mp: 1783,
                cast: 0,
                info:
                    "Brande sua espada causando 2535 de dano físico nos inimigos e perfura em linha reta seus inimigos aplicando sangramento por 5 segundos. Inimigos com sangramento recebem 95% menos cura.",
                necessaryLevel: 97,
            },
            {
                level: 4,
                cooldown: 50,
                mp: 1879,
                cast: 0,
                info:
                    "Brande sua espada causando 2672 de dano físico nos inimigos e perfura em linha reta seus inimigos aplicando sangramento por 5 segundos. Inimigos com sangramento recebem 99% menos cura.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 31,
        name: "Postura Final",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 2995,
                cast: 0,
                info:
                    "Com uma explosão de raiva sangrenta inflige 947 de dano físico nos inimigos em um raio de 6 metros e adiciona dano extra proporcional ao decréscimo de vida. Uma vez ativado os danos são altamente diminuídos por 6 segundos e as curas são pouco efetivas no usuário.",
                necessaryLevel: 95,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 3307,
                cast: 0,
                info:
                    "Com uma explosão de raiva sangrenta inflige 1051 de dano físico nos inimigos em um raio de 6 metros e adiciona dano extra proporcional ao decréscimo de vida. Uma vez ativado os danos são altamente diminuídos por 6 segundos e as curas são pouco efetivas no usuário.",
                necessaryLevel: 99,
            },
        ],
    },
]
